/* Bryan Anthonys — Build Your Stack bundle builder
 *
 * Popup that lets shoppers pick several rings from one collection, shows the
 * "buy more, save more" tier they've reached, and adds the whole stack to the
 * cart in a single request.
 *
 * The discount itself is NOT applied here — Shopify's automatic discounts
 * ("Buy More Save More — X% off Becoming Rings") do that at cart/checkout.
 * The tiers rendered by sections/ba-bundle-builder.liquid mirror those
 * discounts so the popup can preview the savings.
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      switch (name) {
        case 'amount':
          return withCommas + '.' + parts[1];
        case 'amount_no_decimals':
          return withCommas;
        case 'amount_with_comma_separator':
          return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator':
          return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        case 'amount_with_apostrophe_separator':
          return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + parts[1];
        default:
          return match;
      }
    });
  }

  function BundleBuilder(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-ba-bb-data]').textContent);
    this.tiers = (this.data.tiers || []).slice().sort(function (a, b) {
      return a.qty - b.qty;
    });
    this.products = this.data.products || [];
    this.strings = this.data.strings || {};
    this.selection = []; // [{ productId, variantId }]

    this.dialog = root.querySelector('[data-ba-bb-dialog]');
    this.metalWrap = root.querySelector('[data-ba-bb-metals]');
    this.sizeWrap = root.querySelector('[data-ba-bb-sizes]');
    this.grid = root.querySelector('[data-ba-bb-grid]');
    this.tierWrap = root.querySelector('[data-ba-bb-tiers]');
    this.progress = root.querySelector('[data-ba-bb-progress]');
    this.chips = root.querySelector('[data-ba-bb-selection]');
    this.priceWrap = root.querySelector('[data-ba-bb-price]');
    this.savings = root.querySelector('[data-ba-bb-savings]');
    this.submit = root.querySelector('[data-ba-bb-submit]');
    this.error = root.querySelector('[data-ba-bb-error]');

    this.metals = this.uniqueOption('o1');
    this.sizes = this.uniqueOption('o2');
    this.metal = this.metals[0] || null;
    this.size = this.sizes[Math.floor(this.sizes.length / 2)] || this.sizes[0] || null;

    this.onKeydown = this.onKeydown.bind(this);
    this.bind();
    this.renderOptions();
    this.renderGrid();
    this.renderSummary();
  }

  BundleBuilder.prototype.uniqueOption = function (key) {
    var values = [];
    this.products.forEach(function (product) {
      product.variants.forEach(function (variant) {
        if (variant[key] && values.indexOf(variant[key]) === -1) values.push(variant[key]);
      });
    });

    // Sizes sort numerically when they're numbers, alphabetically otherwise.
    var allNumeric = values.every(function (value) {
      return !isNaN(parseFloat(value));
    });

    return allNumeric
      ? values.sort(function (a, b) {
          return parseFloat(a) - parseFloat(b);
        })
      : values;
  };

  BundleBuilder.prototype.variantFor = function (product, metal, size) {
    var wantMetal = metal || this.metal;
    var wantSize = size || this.size;

    return (
      product.variants.filter(function (variant) {
        return (
          (!wantMetal || variant.o1 === wantMetal) && (!wantSize || variant.o2 === wantSize)
        );
      })[0] || null
    );
  };

  BundleBuilder.prototype.productById = function (id) {
    return (
      this.products.filter(function (product) {
        return product.id === id;
      })[0] || null
    );
  };

  BundleBuilder.prototype.isSelected = function (productId) {
    return this.selection.some(function (item) {
      return item.productId === productId;
    });
  };

  /* Rendering -------------------------------------------------------------- */

  BundleBuilder.prototype.renderOptions = function () {
    var self = this;

    if (this.metalWrap) {
      this.metalWrap.innerHTML = '';
      this.metals.forEach(function (metal) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ba-bb__swatch' + (metal === self.metal ? ' is-active' : '');
        button.textContent = metal;
        button.setAttribute('data-ba-bb-metal', metal);
        self.metalWrap.appendChild(button);
      });
    }

    if (this.sizeWrap) {
      this.sizeWrap.innerHTML = '';
      this.sizes.forEach(function (size) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ba-bb__size' + (size === self.size ? ' is-active' : '');
        button.textContent = size;
        button.setAttribute('data-ba-bb-size', size);
        self.sizeWrap.appendChild(button);
      });
    }
  };

  BundleBuilder.prototype.renderGrid = function () {
    var self = this;
    this.grid.innerHTML = '';

    this.products.forEach(function (product) {
      var variant = self.variantFor(product);
      var available = !!(variant && variant.available);
      var selected = self.isSelected(product.id);

      var card = document.createElement('button');
      card.type = 'button';
      card.className =
        'ba-bb__card' +
        (selected ? ' is-selected' : '') +
        (available ? '' : ' is-unavailable');
      card.setAttribute('data-ba-bb-card', product.id);
      if (!available) card.disabled = true;

      var media = '';
      if (product.image) {
        media =
          '<div class="ba-bb__card-image"><img src="' +
          product.image +
          '" alt="" loading="lazy" width="300" height="300"></div>';
      }

      var detail = available
        ? '<span class="ba-bb__card-price">' +
          formatMoney(variant ? variant.price : product.price, self.data.moneyFormat) +
          '</span>'
        : '<span class="ba-bb__card-note">' +
          (self.strings.unavailable || 'Unavailable in this size') +
          '</span>';

      card.innerHTML =
        media +
        '<span class="ba-bb__card-badge">&#10003;</span>' +
        '<span class="ba-bb__card-info">' +
        '<span class="ba-bb__card-title">' +
        product.title +
        '</span>' +
        detail +
        '</span>';

      self.grid.appendChild(card);
    });
  };

  BundleBuilder.prototype.currentTier = function (count) {
    var tier = null;
    this.tiers.forEach(function (candidate) {
      if (count >= candidate.qty) tier = candidate;
    });
    return tier;
  };

  BundleBuilder.prototype.nextTier = function (count) {
    return (
      this.tiers.filter(function (candidate) {
        return candidate.qty > count;
      })[0] || null
    );
  };

  BundleBuilder.prototype.renderSummary = function () {
    var self = this;
    var count = this.selection.length;
    var subtotal = 0;

    this.selection.forEach(function (item) {
      var product = self.productById(item.productId);
      if (!product) return;
      var variant = product.variants.filter(function (candidate) {
        return candidate.id === item.variantId;
      })[0];
      subtotal += variant ? variant.price : product.price;
    });

    var tier = this.currentTier(count);
    var percent = tier ? tier.percent : 0;
    var discount = Math.round((subtotal * percent) / 100);
    var total = subtotal - discount;

    // Tier ladder
    Array.prototype.forEach.call(this.tierWrap.children, function (node) {
      var qty = parseInt(node.getAttribute('data-ba-bb-tier'), 10);
      node.classList.toggle('is-reached', count >= qty);
      node.classList.toggle('is-current', !!tier && tier.qty === qty);
    });

    // Progress message
    var next = this.nextTier(count);
    if (count === 0) {
      this.progress.textContent = this.strings.start || '';
    } else if (next) {
      var remaining = next.qty - count;
      this.progress.textContent = (this.strings.next || '')
        .replace('||count||', remaining)
        .replace('||item||', remaining === 1 ? this.strings.item : this.strings.items)
        .replace('||percent||', next.percent);
    } else {
      this.progress.textContent = (this.strings.max || '').replace('||percent||', percent);
    }

    // Selected chips
    this.chips.innerHTML = '';
    this.selection.forEach(function (item, index) {
      var product = self.productById(item.productId);
      if (!product) return;
      var variant =
        product.variants.filter(function (candidate) {
          return candidate.id === item.variantId;
        })[0] || {};

      var chip = document.createElement('span');
      chip.className = 'ba-bb__chip';

      var metalSelect =
        '<select data-ba-bb-chip-metal="' +
        index +
        '" aria-label="' +
        (self.data.optionNames[0] || 'Metal') +
        '">' +
        self.metals
          .map(function (metal) {
            return (
              '<option value="' +
              metal +
              '"' +
              (metal === variant.o1 ? ' selected' : '') +
              '>' +
              metal +
              '</option>'
            );
          })
          .join('') +
        '</select>';

      var sizeSelect =
        '<select data-ba-bb-chip-size="' +
        index +
        '" aria-label="' +
        (self.data.optionNames[1] || 'Size') +
        '">' +
        self.sizes
          .map(function (size) {
            return (
              '<option value="' +
              size +
              '"' +
              (size === variant.o2 ? ' selected' : '') +
              '>' +
              size +
              '</option>'
            );
          })
          .join('') +
        '</select>';

      chip.innerHTML =
        (product.image ? '<img src="' + product.image + '" alt="" width="26" height="26">' : '') +
        '<span>' +
        product.title +
        '</span>' +
        metalSelect +
        sizeSelect +
        '<button type="button" class="ba-bb__chip-remove" data-ba-bb-remove="' +
        index +
        '" aria-label="Remove">&times;</button>';

      self.chips.appendChild(chip);
    });

    // Totals
    if (count === 0) {
      this.priceWrap.innerHTML = '';
      this.savings.textContent = '';
    } else {
      this.priceWrap.innerHTML =
        '<strong>' +
        formatMoney(total, this.data.moneyFormat) +
        '</strong>' +
        (discount > 0 ? '<del>' + formatMoney(subtotal, this.data.moneyFormat) + '</del>' : '');
      this.savings.textContent =
        discount > 0
          ? (this.strings.savings || '')
              .replace('||percent||', percent)
              .replace('||amount||', formatMoney(discount, this.data.moneyFormat))
          : '';
    }

    this.submit.disabled = count === 0;
    this.submit.textContent =
      count === 0
        ? this.strings.submit_empty || 'Select your rings'
        : (this.strings.submit || 'Add ||count|| to cart')
            .replace('||count||', count)
            .replace('||item||', count === 1 ? this.strings.item : this.strings.items);
  };

  /* Interaction ------------------------------------------------------------ */

  BundleBuilder.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var target = event.target;

      if (target.closest('[data-ba-bb-close]')) {
        self.close();
        return;
      }

      var metal = target.closest('[data-ba-bb-metal]');
      if (metal) {
        self.metal = metal.getAttribute('data-ba-bb-metal');
        self.renderOptions();
        self.renderGrid();
        return;
      }

      var size = target.closest('[data-ba-bb-size]');
      if (size) {
        self.size = size.getAttribute('data-ba-bb-size');
        self.renderOptions();
        self.renderGrid();
        return;
      }

      var card = target.closest('[data-ba-bb-card]');
      if (card) {
        self.toggleProduct(parseInt(card.getAttribute('data-ba-bb-card'), 10));
        return;
      }

      var remove = target.closest('[data-ba-bb-remove]');
      if (remove) {
        self.selection.splice(parseInt(remove.getAttribute('data-ba-bb-remove'), 10), 1);
        self.renderGrid();
        self.renderSummary();
        return;
      }

      if (target.closest('[data-ba-bb-submit]')) self.addToCart();
    });

    this.root.addEventListener('change', function (event) {
      var target = event.target;
      var metalIndex = target.getAttribute('data-ba-bb-chip-metal');
      var sizeIndex = target.getAttribute('data-ba-bb-chip-size');
      var index = metalIndex !== null ? metalIndex : sizeIndex;
      if (index === null) return;

      var item = self.selection[parseInt(index, 10)];
      var product = self.productById(item.productId);
      var current =
        product.variants.filter(function (candidate) {
          return candidate.id === item.variantId;
        })[0] || {};

      var variant = self.variantFor(
        product,
        metalIndex !== null ? target.value : current.o1,
        sizeIndex !== null ? target.value : current.o2
      );

      if (!variant || !variant.available) {
        self.error.textContent = self.strings.unavailable || 'Unavailable in this size';
        self.renderSummary();
        return;
      }

      self.error.textContent = '';
      item.variantId = variant.id;
      self.renderSummary();
    });
  };

  BundleBuilder.prototype.toggleProduct = function (productId) {
    var product = this.productById(productId);
    if (!product) return;

    if (this.isSelected(productId)) {
      this.selection = this.selection.filter(function (item) {
        return item.productId !== productId;
      });
    } else {
      var variant = this.variantFor(product);
      if (!variant || !variant.available) return;
      this.selection.push({ productId: productId, variantId: variant.id });
    }

    this.error.textContent = '';
    this.renderGrid();
    this.renderSummary();
  };

  BundleBuilder.prototype.addToCart = function () {
    var self = this;
    if (!this.selection.length) return;

    // Same ring picked twice (different size) collapses into one line with qty 2.
    var quantities = {};
    this.selection.forEach(function (item) {
      quantities[item.variantId] = (quantities[item.variantId] || 0) + 1;
    });

    var items = Object.keys(quantities).map(function (id) {
      return { id: parseInt(id, 10), quantity: quantities[id] };
    });

    this.submit.disabled = true;
    this.error.textContent = '';

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw new Error(body.description || body.message || '');
          return body;
        });
      })
      .then(function () {
        self.selection = [];
        self.renderGrid();
        self.renderSummary();
        self.close();
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
      })
      .catch(function (error) {
        self.error.textContent =
          error.message || self.strings.error || 'Something went wrong. Please try again.';
        self.submit.disabled = false;
      });
  };

  /* Open / close ----------------------------------------------------------- */

  BundleBuilder.prototype.open = function () {
    var self = this;
    this.root.classList.add('is-open');
    this.lastFocus = document.activeElement;
    // Next frame so the transition runs.
    requestAnimationFrame(function () {
      self.root.classList.add('is-visible');
    });
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('ba-bb-open');
    document.addEventListener('keydown', this.onKeydown);
    this.dialog.setAttribute('tabindex', '-1');
    this.dialog.focus();
  };

  BundleBuilder.prototype.close = function () {
    var self = this;
    this.root.classList.remove('is-visible');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('ba-bb-open');
    document.removeEventListener('keydown', this.onKeydown);
    window.setTimeout(function () {
      self.root.classList.remove('is-open');
    }, 250);
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  BundleBuilder.prototype.onKeydown = function (event) {
    if (event.key === 'Escape') this.close();
  };

  /* Boot ------------------------------------------------------------------- */

  var current = null;
  var triggersBound = false;

  function bindTriggers() {
    if (triggersBound) return;
    triggersBound = true;

    document.addEventListener('click', function (event) {
      if (!current || !event.target || !event.target.closest) return;
      var trigger =
        event.target.closest('[data-ba-bundle-open]') ||
        event.target.closest('a[href$="#build-your-stack"]');
      if (!trigger) return;
      event.preventDefault();
      current.open();
    });
  }

  function onBundlePage(trigger) {
    var path = window.location.pathname;
    return (trigger.paths || []).some(function (candidate) {
      return candidate && path.indexOf(candidate) !== -1;
    });
  }

  function shouldShow(display, trigger) {
    if (display === 'all') return true;
    if (display === 'bundle_pages') return onBundlePage(trigger);
    return false;
  }

  // Slim "stack & save" bar, placed above the page content so the tiers are
  // visible before the popup is ever opened.
  function renderBar(builder) {
    if (document.querySelector('.ba-bb-bar')) return;

    var banner = builder.data.banner || {};
    if (!shouldShow(banner.display, builder.data.trigger || {})) return;

    var bar = document.createElement('div');
    bar.className = 'ba-bb-bar';
    bar.setAttribute('data-ba-bb-bar', '');

    var label = document.createElement('span');
    label.className = 'ba-bb-bar__label';
    label.textContent = banner.label || 'Stack & save';
    bar.appendChild(label);

    var tiers = document.createElement('span');
    tiers.className = 'ba-bb-bar__tiers';
    builder.tiers.forEach(function (tier) {
      var chip = document.createElement('span');
      chip.className = 'ba-bb-bar__tier';
      chip.innerHTML =
        '<b>' + tier.percent + '% off</b> ' +
        (banner.tier || '||count||+').replace('||count||', tier.qty);
      tiers.appendChild(chip);
    });
    bar.appendChild(tiers);

    if (banner.cta) {
      var cta = document.createElement('button');
      cta.type = 'button';
      cta.className = 'ba-bb-bar__cta';
      cta.textContent = banner.cta;
      cta.setAttribute('data-ba-bundle-open', '');
      bar.appendChild(cta);
    }

    builder.root.parentNode.insertBefore(bar, builder.root);
  }

  // The section renders from a section group, which sits outside the template,
  // so it can't tell which page it's on. Place the button from here instead.
  function renderTrigger(builder) {
    if (document.querySelector('.ba-bb-trigger')) return;

    var trigger = builder.data.trigger || {};
    if (!shouldShow(trigger.display, trigger)) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ba-bb-trigger';
    button.textContent = trigger.label || 'Build a stack & save';
    button.setAttribute('data-ba-bundle-open', '');
    document.body.appendChild(button);
  }

  function init() {
    var root = document.querySelector('[data-ba-bb]');
    if (!root || root.dataset.baBbReady === 'true') return;

    try {
      current = new BundleBuilder(root);
    } catch (e) {
      return;
    }

    root.dataset.baBbReady = 'true';
    window.baBundleBuilder = current;
    bindTriggers();
    renderBar(current);
    renderTrigger(current);

    if (window.location.hash === '#build-your-stack') current.open();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sections rendered/re-rendered by the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
